import { useCallback, useContext, useMemo, useState } from 'react'

import { HttpMethod, browserStorageKeys } from '@/Shared/domain'
import { axiosFetch, getTokenConfig } from '@/Shared/infrastructure'
import { loginSiteUrl } from '@/Shared/infrastructure/dynamicEndpoints'
import { logout } from '@/Shared/infrastructure/endpoints'
import { AuthContext, AuthContextProps } from '@/Shared/ui/auth'

export const AuthProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const [isLogged, setIsLogged] = useState(false)

  const logIn = useCallback(async () => {
    try {
      const { data: appToken } = await getTokenConfig({
        url: 'token',
        method: 'GET',
        headers: {
          cors: 'no-cors',
        },
      })

      storeToken(appToken.data)

      setIsLogged(true)
    } catch (error) {
      setIsLogged(true)
    }
  }, [])

  const storeToken = (token: string): void => {
    window.localStorage.setItem(browserStorageKeys.token, token)
  }

  const logOut = useCallback(async () => {
    try {
      await axiosFetch(logout, HttpMethod.POST).then(() => {
        sessionStorage.clear()
        localStorage.clear()
        setIsLogged(false)
        window.location.href = loginSiteUrl
      })
    } catch (error) {
      // do nothing
    }
  }, [])

  const value = useMemo(
    () => ({
      logIn,
      logOut,
      storeToken,
      isLogged,
    }),
    [logIn, logOut, isLogged],
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
export const useAuth = (): AuthContextProps => useContext(AuthContext)
